import * as React from 'react';
import '../Login/login.scss';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { AdapterLink } from '../AdapterLink';
import SimpleSnackbar from '../SimpleSnackbar';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
    },
    img_logo: {
      width: 350,
      marginBottom: 10,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 20,
    },
    menu: {
      width: 200,
    },
    button: {
      margin: theme.spacing(1),
      marginTop: 20,
    },
    input: {
      display: 'none',
    },
  }),
);

interface IValueState {
  username: string;
  code: string;
  password: string;
  errorMessages: string[];
  usernameHasError: boolean;
}

export const ForgotPassword: React.FC<RouteComponentProps> = props => {
  const auth = React.useContext(AuthContext);
  const classes = useStyles();

  const [values, setValues] = React.useState<IValueState>({
    username: '',
    code: '',
    password: '',
    usernameHasError: false,
    errorMessages: [],
  });

  const { from } = props.location.state || { from: { pathname: '/' } };
 
  if (auth.hasValidSession && !auth.requireVerification) {
    return <Redirect to={from} />;
  }

  if (auth.requireVerification && !auth.hasValidSession) {
    return <Redirect to={'/verify'} />;
  }

  if (auth.resetNewPassword && !auth.hasValidSession) {
    return <Redirect to={'/reset'} />;
  }

  const validateForm = (username: string) => {
    let err: string = '';
    if (!username) {
      err = 'Please enter email.';
    }

    setValues({
      ...values,
      errorMessages: [...values.errorMessages, err],
      usernameHasError: !username
    });

    return !!username;
  };

  const inputOnKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.keyCode === 13) {  // if "Enter"
      e.preventDefault();
      handleForgotPwd();
    }
  };

  const handleForgotPwd = async () => {
    try {
      const { username, password, code } = values;
      const inputIsValid = validateForm(username);

      if (inputIsValid) {
        setValues({
          ...values,
          errorMessages: [],
          usernameHasError: false,
        });


        auth.forgotPassword && (await auth.forgotPassword(1, {username, password, code}));
        setValues({
          ...values,
          errorMessages: ['Reset code sent in mail successfully. Please use the confirm code for reset new password.'],
        });
        props.history.push('/reset');
      }
    } catch (error) {
      setValues({
        ...values,
        errorMessages: [error.message],
      });
    }
  };

  return (
    <div className="login-page">
      <div  className="login forget-password">
        <img src={require('../../assets/images/lawdroid-voice-logo.png')} alt="Lawdroid Logo" className={classes.img_logo}/>
        <form className={classes.container} noValidate autoComplete="off"  onKeyDown={inputOnKeyDown}>
          {values.errorMessages &&
            values.errorMessages.map(
              (err, i) => !!err && <SimpleSnackbar key={i} message={err} />,
            )}
          <h2>Forgot Password</h2>
          <TextField
            error={values.usernameHasError}
            id="standard-name"
            placeholder="Email"
            className={classes.textField}
            value={values.username}
            onChange={e => {
              setValues({ ...values, username: e.target.value });
            }}
          />
          <Button
            onClick={handleForgotPwd}
            variant="contained"
            color="primary"
            className={classes.button}
          >
            Send Code
          </Button>
          <div className="login-secondaryActions">
            <Button
              className={classes.button}
              component={AdapterLink}
              to="/login"
            >
              Back to Sign In
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
